import { BaseModel } from "@/models/base.model"
import { type IBase } from "@/interfaces/api/base.interface"
import { BaseRepository } from "@/repositories/base-repository"
import { type ModelConstructorSignature } from "@/models/types/model-constructor-signature"
import { type IStoreFunctionsConfig } from "@/store/base-functions/base-store-functions"
import { ODataQueryBuilder } from "@/builder/odata-query-builder"
import { KnownBusinessEntity } from "@/models/known-business-entity.model.ts"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"

export abstract class AbstractKnownBusinessEntityAdministrativeItemController<
  Model extends BaseModel,
  IData extends IBase,
  Repository extends BaseRepository<IData>
> extends GenericModelController<Model, IData, Repository> {
  protected retrievedForKnownBusinessEntities: Set<string> = new Set()

  protected constructor(
    modelType: ModelConstructorSignature<IData, Model>,
    storeFunctionsConfig: IStoreFunctionsConfig<Model>,
    repository: Repository
  ) {
    super(modelType, storeFunctionsConfig, repository)
  }

  public async getListForKnownBusinessEntity(
    knownBusinessEntity: KnownBusinessEntity
  ): Promise<void> {
    if (this.retrievedForKnownBusinessEntities.has(knownBusinessEntity.id!)) {
      return
    }
    this.retrievedForKnownBusinessEntities.add(knownBusinessEntity.id!)

    const query = new ODataQueryBuilder().eq("known_business_entity_id", knownBusinessEntity.id!)
    await this.getList({ query })
  }
}
